import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { useSliderContext } from '../../../../utils/sliderContext';
export var EventManager = function EventManager(_ref) {
  var onSlideChange = _ref.onSlideChange;

  var _useSliderContext = useSliderContext(),
      currentSlideIndex = _useSliderContext.currentSlide;

  var _React$useState = React.useState(currentSlideIndex),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      currentSlide = _React$useState2[0],
      setCurrentSlide = _React$useState2[1];

  React.useEffect(function () {
    if (currentSlide === currentSlideIndex) {
      return;
    }

    if (onSlideChange) {
      onSlideChange(currentSlideIndex);
    }

    setCurrentSlide(currentSlideIndex); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSlideIndex]);
  return null;
};